













import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";

import TagSelectForm from "@/components/Organisms/OnboardingFloatingView/Organisms/TagSelectForm/index.vue";

import { getTopUniversityFollowees } from "@/api";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "UniversitiesForm",
  components: {
    TagSelectForm
  },
  props: {
    universities: {
      type: Array as PropType<Props["universities"]>,
      required: true
    }
  },
  data() {
    return {
      suggestionUniversities: [],
      topUniversity: [],
      loadingTopUniversity: false
    };
  },
  mounted() {
    this.getTopUniversities();
  },
  methods: {
    async searchUniversity(keyword) {
      if (!keyword) {
        this.suggestionUniversities = [];
        return;
      }
      const { data } = await getTopUniversityFollowees({
        name: keyword,
        limit: 999
      });
      this.suggestionUniversities = data.universities;
    },
    async getTopUniversities() {
      this.loadingTopUniversity = true;
      const response = await getTopUniversityFollowees({ limit: 5 });
      this.topUniversity = response.data.universities;
      this.loadingTopUniversity = false;
    }
  }
});
